(() => {
  const qs = (s, root=document) => root.querySelector(s);
  const qsa = (s, root=document) => [...root.querySelectorAll(s)];
  const escapeHtml = (str='') => String(str).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const shuffleArray = input => { const arr=[...input]; for(let i=arr.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[arr[i],arr[j]]=[arr[j],arr[i]];} return arr; };

  function setBodyLock() {
    const open = qsa('[data-mobile-menu]:not([hidden]),[data-search-panel]:not([hidden])').length > 0;
    document.documentElement.classList.toggle('jfcs-overlay-open', open);
  }

  function initHeader(root=document) {
    qsa('[data-header]', root).forEach(header => {
      if (header.dataset.jfcsBound) return;
      header.dataset.jfcsBound = '1';
      const menuBtn = qs('[data-menu-toggle]', header), menu = qs('[data-mobile-menu]', header), menuClose = qs('[data-menu-close]', header);
      const searchBtn = qs('[data-search-toggle]', header), searchPanel = qs('[data-search-panel]', header), searchClose = qs('[data-search-close]', header);
      const closeMenu = () => { if(menu){menu.hidden=true;menuBtn?.setAttribute('aria-expanded','false');setBodyLock();} };
      const openMenu = () => { if(menu){menu.hidden=false;menuBtn?.setAttribute('aria-expanded','true'); if(searchPanel) searchPanel.hidden=true; setBodyLock();} };
      const closeSearch = () => { if(searchPanel){searchPanel.hidden=true;searchBtn?.setAttribute('aria-expanded','false');setBodyLock();} };
      const openSearch = () => { if(searchPanel){searchPanel.hidden=false;searchBtn?.setAttribute('aria-expanded','true'); if(menu) menu.hidden=true; setBodyLock(); setTimeout(()=>qs('input',searchPanel)?.focus(),0);} };
      menuBtn?.addEventListener('click',()=>menu?.hidden?openMenu():closeMenu()); menuClose?.addEventListener('click',closeMenu);
      menu?.addEventListener('click',event=>{
        const link=event.target.closest?.('a[href]');
        if(!link)return;
        closeMenu();
        requestAnimationFrame(()=>{
          if(menu.hidden&&(!searchPanel||searchPanel.hidden))document.documentElement.classList.remove('jfcs-overlay-open');
        });
      });
      searchBtn?.addEventListener('click',()=>searchPanel?.hidden?openSearch():closeSearch()); searchClose?.addEventListener('click',closeSearch);
      document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeMenu();closeSearch();}});
      window.addEventListener('pageshow',setBodyLock);
    });

    qsa('[data-predictive-input]', root).forEach(searchInput => {
      if (searchInput.dataset.jfcsBound) return;
      const scope = searchInput.closest('[data-search-panel]') || document, searchResults = qs('[data-predictive-results]', scope);
      if (!searchResults) return;
      searchInput.dataset.jfcsBound = '1'; let timer, controller;
      searchInput.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort(); const q=searchInput.value.trim();
        if(q.length<2){searchResults.innerHTML='';return;}
        timer=setTimeout(async()=>{try{controller=new AbortController();const endpoint=window.JFCS?.routes?.predictive||'/search/suggest';const url=`${endpoint}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6`;const data=await fetch(url,{headers:{Accept:'application/json'},signal:controller.signal}).then(r=>r.json());const res=data?.resources?.results||{};const items=[...(res.products||[]),...(res.collections||[]),...(res.pages||[])];searchResults.innerHTML=items.length?items.map(x=>`<a href="${x.url}"><strong>${escapeHtml(x.title)}</strong><span>${x.type?escapeHtml(x.type):''}</span></a>`).join(''):'<p>No evidence found.</p>';}catch(e){if(e.name!=='AbortError')searchResults.innerHTML='';}},180);
      });
    });
  }

  function initHeroes(root=document) {
    qsa('[data-jfcs-hero]', root).forEach(section=>{
      const frame=qs('[data-hero-frame]',section),configEl=qs('[data-hero-config]',section);
      if(!frame||!configEl)return;
      let heroes=[];
      try{heroes=JSON.parse(configEl.textContent).heroes||[]}catch(e){}
      if(!heroes.length)return;
      const forced=(location.hash.match(/jfcsHero=([A-F])/i)||[])[1]?.toUpperCase();
      let id=forced||sessionStorage.getItem('jfcsHero');
      if(!heroes.some(h=>h.id===id)){id=heroes[Math.floor(Math.random()*heroes.length)].id;sessionStorage.setItem('jfcsHero',id)}
      const hero=heroes.find(h=>h.id===id)||heroes[0];
      const stage=document.createElement('div'); stage.className='hero-stage'; stage.setAttribute('data-hero-stage','');
      const picture=document.createElement('picture');
      const source=document.createElement('source'); source.media='(max-width:760px)'; source.srcset=hero.mobile;
      const img=document.createElement('img'); img.src=hero.desktop; img.alt=`JFCS featured hero ${hero.id}`; img.fetchPriority='high'; img.decoding='async';
      picture.append(source,img); stage.appendChild(picture); frame.replaceChildren(stage);
      frame.style.setProperty('--jfcs-hero-bg',`url("${String(hero.desktop).replace(/"/g,'\"')}")`);
      if(hero.wiilImageLink){
        const mobileWiil=document.createElement('a');
        mobileWiil.className='hero-mobile-wiil-link';
        mobileWiil.href='/collections/95-wiil-rock';
        mobileWiil.setAttribute('aria-label',`Shop 95 WIIL ROCK from hero ${hero.id}`);
        mobileWiil.title='Shop 95 WIIL ROCK';
        stage.appendChild(mobileWiil);
      }
      const hotspots=document.createElement('div'); hotspots.className='hero-hotspots'; hotspots.setAttribute('aria-label',`Hero ${hero.id} quick links`);
      (hero.hotspots||[]).forEach((spot,index)=>{
        const a=document.createElement('a'); a.className='hero-hotspot'; a.href=spot.href; a.setAttribute('aria-label',spot.label||'Open link'); a.title=spot.label||'';
        a.style.left=`${spot.x}%`; a.style.top=`${spot.y}%`; a.style.width=`${spot.w}%`; a.style.height=`${spot.h}%`; a.dataset.heroHotspot=String(index+1);
        hotspots.appendChild(a);
      });
      stage.appendChild(hotspots); section.dataset.heroActive=hero.id;
      const primary=qs('[data-hero-primary]',section), secondary=qs('[data-hero-secondary]',section);
      if(primary&&hero.primary){primary.href=hero.primary.href;primary.textContent=hero.primary.label;}
      if(secondary&&hero.secondary){secondary.href=hero.secondary.href;secondary.textContent=hero.secondary.label;}
    });
  }

  function initEvidenceLocker(root=document) {
    qsa('[data-evidence-locker]',root).forEach(locker=>{
      if(locker.dataset.jfcsBound) return;
      locker.dataset.jfcsBound='1';
      const tabs=qsa('[data-locker-tab]',locker), panels=qsa('[data-locker-panel]',locker);
      const lazyLoads=new WeakMap();
      const currency=window.Shopify?.currency?.active||'USD';
      const shopRoot=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
      const formatPrice=value=>{
        const number=Number(value||0);
        try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(number)}catch(e){return `$${number.toFixed(2)}`}
      };
      const productPrice=product=>{
        const prices=(product?.variants||[]).map(variant=>Number(variant.price)).filter(Number.isFinite);
        return prices.length?Math.min(...prices):0;
      };
      const productCard=(product,{label,source=''})=>{
        const handle=String(product?.handle||'').trim();
        if(!handle) return '';
        const title=escapeHtml(product?.title||'Untitled product');
        const vendor=escapeHtml(product?.vendor||'');
        const url=`${shopRoot}products/${encodeURIComponent(handle)}`;
        const image=product?.images?.[0]?.src||product?.image?.src||'';
        const media=image?`<img src="${escapeHtml(image)}" alt="${title}" loading="lazy" width="900" decoding="async">`:'<div class="jfcs-card__placeholder">NO IMAGE</div>';
        const sourceAttr=source?` data-evidence-source="${escapeHtml(source)}"`:'';
        return `<article class="jfcs-card evidence-candidate" data-evidence-candidate${sourceAttr} data-evidence-title="${escapeHtml(handle)}" hidden><a class="jfcs-card__media" href="${url}">${media}</a><div class="jfcs-card__body"><span class="evidence-label">${escapeHtml(label)}</span>${vendor?`<span class="jfcs-card__vendor">${vendor}</span>`:''}<h3><a href="${url}">${title}</a></h3><span class="jfcs-price">${formatPrice(productPrice(product))}</span><a class="jfcs-btn jfcs-btn--outline" href="${url}">VIEW PRODUCT</a></div></article>`;
      };
      const fetchCollection=async handles=>{
        for(const handle of handles){
          try{
            const response=await fetch(`${shopRoot}collections/${encodeURIComponent(handle)}/products.json?limit=24`,{headers:{Accept:'application/json'}});
            if(!response.ok) continue;
            const data=await response.json();
            if(Array.isArray(data?.products)&&data.products.length) return {handle,products:data.products};
          }catch(e){}
        }
        return {handle:handles[0],products:[]};
      };
      const randomizePanel=panel=>{
        const candidates=qsa('[data-evidence-candidate]',panel);
        if(!candidates.length) return;
        candidates.forEach(card=>card.hidden=true);
        const usedTitles=new Set();
        const picks=[];
        if(panel.dataset.lockerPanel==='under50'){
          const grouped=new Map();
          candidates.forEach(card=>{
            const source=card.dataset.evidenceSource||'other';
            if(!grouped.has(source)) grouped.set(source,[]);
            grouped.get(source).push(card);
          });
          shuffleArray([...grouped.keys()]).forEach(source=>{
            if(picks.length>=4) return;
            const pool=shuffleArray(grouped.get(source)||[]);
            const choice=pool.find(card=>{
              const title=card.dataset.evidenceTitle||'';
              return title&&!usedTitles.has(title);
            });
            if(choice){picks.push(choice);usedTitles.add(choice.dataset.evidenceTitle||'');}
          });
        }else{
          shuffleArray(candidates).forEach(card=>{
            if(picks.length>=4) return;
            const title=card.dataset.evidenceTitle||'';
            if(!title||usedTitles.has(title)) return;
            usedTitles.add(title);picks.push(card);
          });
        }
        picks.forEach(card=>card.hidden=false);
      };
      const ensureLazyPanel=panel=>{
        if(!panel?.dataset.lockerLazy||panel.dataset.lockerLoaded==='1') return Promise.resolve();
        if(lazyLoads.has(panel)) return lazyLoads.get(panel);
        const task=(async()=>{
          const grid=qs('[data-locker-lazy-grid]',panel);
          if(!grid) return;
          grid.innerHTML='<div class="locker-empty"><strong>LOADING LIVE EVIDENCE…</strong><span>Pulling a fresh batch of evidence now.</span></div>';
          try{
            if(panel.dataset.lockerLazy==='repeat'){
              const {products}=await fetchCollection(['95-wiil-rock']);
              const unique=[]; const titles=new Set();
              products.sort((a,b)=>new Date(a.created_at||0)-new Date(b.created_at||0)).forEach(product=>{
                const key=String(product?.title||'').trim().toLowerCase();
                if(!key||titles.has(key)||unique.length>=24) return;
                titles.add(key);unique.push(product);
              });
              grid.innerHTML=unique.length?unique.map(product=>productCard(product,{label:'REPEAT OFFENDER / ROCK ARCHIVE'})).join(''):'<div class="locker-empty"><strong>NO REPEAT OFFENDERS FOUND.</strong></div>';
            }else if(panel.dataset.lockerLazy==='under50'){
              const sources=[
                {bucket:'badass-food',handles:['badass-food','badass-food-product']},
                {bucket:'pet-sh-t',handles:['pet-sh-t','pet-toys','pet-sht']},
                {bucket:'jewelry',handles:['jewelry']},
                {bucket:'gifts-novelties',handles:['gifts-novelties','extra-cool-shit','extra-cool-shit-gifts']},
                {bucket:'apparel',handles:['apparel']}
              ];
              const results=await Promise.all(sources.map(async source=>({source,result:await fetchCollection(source.handles)})));
              const cards=[];
              results.forEach(({source,result})=>{
                const unique=[]; const titles=new Set();
                result.products.sort((a,b)=>productPrice(a)-productPrice(b)).forEach(product=>{
                  const key=String(product?.title||'').trim().toLowerCase();
                  if(productPrice(product)>50||!key||titles.has(key)||unique.length>=5) return;
                  titles.add(key);unique.push(product);
                });
                unique.forEach(product=>cards.push(productCard(product,{label:'BAD IDEA UNDER $50',source:source.bucket})));
              });
              grid.innerHTML=cards.length?cards.join(''):'<div class="locker-empty"><strong>NO EVIDENCE UNDER $50.</strong></div>';
            }
            panel.dataset.lockerLoaded='1';
          }catch(e){
            grid.innerHTML='<div class="locker-empty"><strong>LIVE EVIDENCE TEMPORARILY UNAVAILABLE.</strong><span>Try the tab again or open the full locker.</span></div>';
          }
        })();
        lazyLoads.set(panel,task);
        task.finally(()=>lazyLoads.delete(panel));
        return task;
      };
      panels.filter(panel=>!panel.dataset.lockerLazy).forEach(randomizePanel);
      const activate=async(id,reroll=false)=>{
        tabs.forEach(t=>{const active=t.dataset.lockerTab===id;t.classList.toggle('is-active',active);t.setAttribute('aria-selected',String(active))});
        const activePanel=panels.find(panel=>panel.dataset.lockerPanel===id);
        panels.forEach(panel=>{const active=panel===activePanel;panel.classList.toggle('is-active',active);panel.toggleAttribute('hidden',!active)});
        if(activePanel){await ensureLazyPanel(activePanel);if(reroll||activePanel.dataset.lockerLazy)randomizePanel(activePanel)}
      };
      tabs.forEach(tab=>tab.addEventListener('click',()=>{activate(tab.dataset.lockerTab,true)}));
      qsa('[data-new-shit-link]').forEach(link=>link.addEventListener('click',event=>{if(window.location.pathname==='/'||window.location.pathname===''){event.preventDefault();activate('new',true);history.replaceState(null,'','#new-shit');locker.scrollIntoView({behavior:'smooth',block:'start'})}}));
      if(window.location.hash==='#new-shit') activate('new',true);
    });
  }

  function initWtf(root=document) {
    qsa('[data-wtf-tool]',root).forEach(tool=>{
      if(tool.dataset.jfcsBound) return;
      const button=qs('[data-wtf-judge]',tool), result=qs('[data-wtf-result]',tool), productsEl=qs('[data-wtf-products]',tool);
      if(!button||!result||!productsEl) return;
      tool.dataset.jfcsBound='1';
      let products=[];
      try{products=JSON.parse(productsEl.textContent)}catch(e){}
      button.addEventListener('click',()=>{
        if(!products.length){result.hidden=false;result.innerHTML='<p>The live catalog is not available to this theme preview yet.</p>';return;}
        const budget=Number(qs('[data-wtf-budget]',tool)?.value||99999);
        const weird=qs('[data-wtf-weird]',tool)?.value||'weird';
        const person=qs('[data-wtf-person]',tool)?.value||'EVERYONE';
        let pool=products.filter(p=>Number(p.price)<=budget);
        const categoryPool=pool.filter(p=>{
          if(weird==='food') return p.bucket==='badass-food';
          if(weird==='pet') return p.bucket==='pet-sh-t';
          if(weird==='weird') return p.bucket==='gifts-novelties';
          return ['95-wiil-rock','apparel','jewelry'].includes(p.bucket);
        });
        if(categoryPool.length) pool=categoryPool;
        if(!pool.length) pool=products;
        const pick=pool[Math.floor(Math.random()*pool.length)];
        const verdicts={
          'MY NEIGHBORS':'Your neighbors will absolutely have questions.',
          'MY BOSS':'This is excellent material for an awkward workplace conversation.',
          'MY FAMILY':'The family group chat is about to become more interesting.',
          'EVERYONE':'Maximum collateral confusion achieved.'
        };
        result.hidden=false;
        result.innerHTML=`<div class="wtf-result-card">${pick.image?`<img src="${pick.image}" alt="">`:''}<div><p class="eyebrow">THE VERDICT</p><h3>${escapeHtml(pick.title)}</h3><p>${escapeHtml(verdicts[person]||verdicts.EVERYONE)} Scientifically unverified. Emotionally correct.</p><a class="jfcs-btn jfcs-btn--primary" href="${pick.url}">MAKE THE BAD DECISION</a></div></div>`;
      });
    });
  }

  function initHomepageRandomLinks(root=document) {
    if(!document.body.classList.contains('template-index')) return;
    qsa('a[href]',root).forEach(link=>{
      if(link.dataset.jfcsShuffleLink) return;
      let url;
      try{url=new URL(link.getAttribute('href'),location.origin)}catch(e){return;}
      if(url.origin!==location.origin) return;
      if(!/^\/collections\/[^/]+\/?$/.test(url.pathname)) return;
      url.searchParams.set('shuffle','1');
      link.setAttribute('href',`${url.pathname}${url.search}${url.hash}`);
      link.dataset.jfcsShuffleLink='1';
    });
  }

  function initRandomCollection(root=document) {
    const page=qs('[data-collection-page]',root);
    if(!page||page.dataset.jfcsRandomBound) return;
    const params=new URLSearchParams(location.search);
    if(params.get('shuffle')!=='1') return;
    if([...params.keys()].some(key=>key.startsWith('filter.'))) return;
    const match=location.pathname.match(/^\/collections\/([^/]+)\/?$/);
    if(!match) return;
    const handle=decodeURIComponent(match[1]);
    const grid=qs('.collection-product-grid',page);
    if(!grid) return;
    page.dataset.jfcsRandomBound='1';
    const serverPagination=qs('.pagination',page);
    const toolbar=qs('.collection-toolbar',page);
    const newArrivalsMode=handle==='all'&&params.get('view')==='new-arrivals';
    const pageSize=24;
    let products=[],pageIndex=0;
    const money=value=>{const n=Number(value||0);return Number.isFinite(n)?new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n):''};
    const normalizeTitle=title=>String(title||'').trim().toLowerCase().replace(/\s+/g,' ');
    const renderCard=product=>{
      const href=`/products/${encodeURIComponent(product.handle)}`;
      const image=product.images?.[0]?.src||product.image?.src||'';
      const variants=product.variants||[];
      const price=variants.length?Math.min(...variants.map(v=>Number(v.price||0))):0;
      const availableVariants=variants.filter(v=>v.available!==false);
      const hasOptions=variants.length>1||(product.options||[]).some(o=>String(o.name||'').toLowerCase()!=='title');
      const singleVariant=!hasOptions&&variants.length===1?variants[0]:null;
      const article=document.createElement('article');
      article.className='jfcs-card jfcs-random-card';
      let action='';
      if(singleVariant&&singleVariant.available!==false){
        action=`<form method="post" action="/cart/add" class="jfcs-card__quick" data-ajax-cart-add><input type="hidden" name="id" value="${singleVariant.id}"><input type="hidden" name="quantity" value="1"><button class="jfcs-btn jfcs-btn--outline" type="submit">ADD TO BAG</button></form>`;
      }else if(!availableVariants.length){
        action=`<a class="jfcs-btn jfcs-btn--outline is-disabled" href="${href}">SOLD OUT</a>`;
      }else{
        action=`<a class="jfcs-btn jfcs-btn--outline" href="${href}">${hasOptions?'CHOOSE OPTIONS':'VIEW PRODUCT'}</a>`;
      }
      article.innerHTML=`<a class="jfcs-card__media" href="${href}">${image?`<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy">`:'<div class="jfcs-card__placeholder">NO IMAGE</div>'}</a><div class="jfcs-card__body">${product.vendor?`<span class="jfcs-card__vendor">${escapeHtml(product.vendor)}</span>`:''}<h3><a href="${href}">${escapeHtml(product.title)}</a></h3><span class="jfcs-price">${money(price)}</span>${action}</div>`;
      return article;
    };
    let controls=qs('[data-random-collection-controls]',page);
    if(!controls){
      controls=document.createElement('nav');
      controls.className='random-collection-controls';
      controls.dataset.randomCollectionControls='';
      controls.setAttribute('aria-label','Randomized product pages');
      controls.innerHTML='<button type="button" data-random-prev>← PREVIOUS</button><span data-random-status></span><button type="button" data-random-next>NEXT →</button><button type="button" data-random-reshuffle>RESHUFFLE PRODUCTS</button>';
      grid.insertAdjacentElement('afterend',controls);
    }
    const prev=qs('[data-random-prev]',controls),next=qs('[data-random-next]',controls),reshuffle=qs('[data-random-reshuffle]',controls),status=qs('[data-random-status]',controls);
    const renderPage=()=>{
      const pages=Math.max(1,Math.ceil(products.length/pageSize));
      if(pageIndex>=pages)pageIndex=pages-1;
      if(pageIndex<0)pageIndex=0;
      const batch=products.slice(pageIndex*pageSize,(pageIndex+1)*pageSize);
      grid.replaceChildren(...batch.map(renderCard));
      if(status)status.textContent=`RANDOM PAGE ${pageIndex+1} OF ${pages} · ${products.length} PRODUCTS`;
      if(prev)prev.disabled=pageIndex===0;
      if(next)next.disabled=pageIndex>=pages-1;
      initAjaxCart(grid);
    };
    prev?.addEventListener('click',()=>{pageIndex--;renderPage();grid.scrollIntoView({behavior:'smooth',block:'start'});});
    next?.addEventListener('click',()=>{pageIndex++;renderPage();grid.scrollIntoView({behavior:'smooth',block:'start'});});
    reshuffle?.addEventListener('click',()=>{products=shuffleArray(products);pageIndex=0;renderPage();grid.scrollIntoView({behavior:'smooth',block:'start'});});
    const marker=document.createElement('span');
    marker.className='collection-random-marker';
    marker.textContent='RANDOMIZED FROM HOMEPAGE';
    toolbar?.querySelector('div')?.appendChild(marker);
    const source=`/collections/${encodeURIComponent(handle)}/products.json?limit=250`;
    const load=async()=>{
      const data=await fetch(source,{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error('Random feed unavailable');return r.json()});
      let pool=data.products||[];
      if(newArrivalsMode){
        const wiil=await fetch('/collections/95-wiil-rock/products.json?limit=250',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():{products:[]}).catch(()=>({products:[]}));
        const excluded=new Set((wiil.products||[]).map(product=>product.handle));
        pool=pool.filter(product=>!excluded.has(product.handle));
      }
      const seen=new Set();
      pool=pool.filter(product=>{const key=normalizeTitle(product.title);if(!key||seen.has(key))return false;seen.add(key);return true;});
      products=shuffleArray(pool);
      if(!products.length)throw new Error('No randomized products available');
      if(serverPagination)serverPagination.hidden=true;
      renderPage();
    };
    load().catch(()=>{controls?.remove();marker?.remove();page.dataset.jfcsRandomBound='fallback';});
  }

  function initCollection(root=document) {
    qsa('[data-apparel-extended]',root).forEach(section=>{
      if(section.dataset.jfcsBound) return;
      section.dataset.jfcsBound='1';
      const grid=qs('[data-apparel-extended-grid]',section), more=qs('[data-apparel-extended-more]',section), status=qs('[data-apparel-extended-status]',section);
      if(!grid) return;
      const source=section.dataset.source||'/collections/95-wiil-rock/products.json?limit=250';
      const existing=new Set(qsa('.collection-product-grid .jfcs-card h3 a').map(a=>a.getAttribute('href')).filter(Boolean).map(h=>h.split('?')[0]));
      const garmentPattern=/(t[ -]?shirt|tshirt|shirt|tee\b|hoodie|sweater|jacket|flannel|hat\b|hats\b|beanie|cap\b|sock|sleeveless|raglan|jersey|polo|tank\b|vest\b|pants|shorts|rasta skull)/i;
      const nonGarmentPattern=/(bottle opener|coffee|mug|tumbler|koozie|sticker|decal|keychain|poster|sign\b|glass\b|cup\b|blanket|custom order$)/i;
      const pageSize=24;
      let products=[],shown=0;
      const money=value=>{const n=Number(value||0);return Number.isFinite(n)?`$${n.toFixed(2)}`:''};
      const renderCard=product=>{
        const href=`/products/${encodeURIComponent(product.handle)}`;
        const image=product.images?.[0]?.src||product.image?.src||'';
        const variants=product.variants||[];
        const price=variants.length?Math.min(...variants.map(v=>Number(v.price||0))):0;
        const hasOptions=variants.length>1 || (product.options||[]).some(o=>String(o.name||'').toLowerCase()!=='title');
        const article=document.createElement('article');article.className='jfcs-card apparel-extended__card';
        article.innerHTML=`<a class="jfcs-card__media" href="${href}">${image?`<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy">`:'<div class="jfcs-card__placeholder">NO IMAGE</div>'}</a><div class="jfcs-card__body"><span class="jfcs-card__vendor">95 WIIL ROCK</span><h3><a href="${href}">${escapeHtml(product.title)}</a></h3><span class="jfcs-price">${money(price)}</span><a class="jfcs-btn jfcs-btn--outline" href="${href}">${hasOptions?'CHOOSE OPTIONS':'VIEW PRODUCT'}</a></div>`;
        return article;
      };
      const renderNext=()=>{
        const batch=products.slice(shown,shown+pageSize);batch.forEach(p=>grid.appendChild(renderCard(p)));shown+=batch.length;
        if(more) more.hidden=shown>=products.length;
        if(status) status.textContent=products.length?`Showing ${shown} of ${products.length} additional WIIL Rock apparel items.`:'No additional WIIL Rock apparel items were found.';
      };
      fetch(source,{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error('Apparel feed unavailable');return r.json()}).then(data=>{
        products=(data.products||[]).filter(product=>{
          const title=String(product.title||'');
          const href=`/products/${encodeURIComponent(product.handle)}`;
          if(existing.has(href)) return false;
          return garmentPattern.test(title)&&!nonGarmentPattern.test(title);
        });
        if(new URLSearchParams(location.search).get('shuffle')==='1') products=shuffleArray(products);
        grid.innerHTML='';
        const total=25+products.length;
        qsa('[data-apparel-total]').forEach(el=>el.textContent=String(total));
        qsa('[data-apparel-toolbar-count]').forEach(el=>el.textContent=`${total} CLOTHING ITEMS`);
        if(!products.length){grid.innerHTML='<div class="locker-empty"><strong>NO EXTRA ROCK APPAREL FOUND.</strong><span>The core Apparel collection is still available above.</span></div>';if(status)status.textContent='';return;}
        renderNext();
        more?.addEventListener('click',renderNext);
      }).catch(()=>{
        grid.innerHTML='<div class="locker-empty"><strong>ROCK APPAREL TEMPORARILY UNAVAILABLE.</strong><span>Open 95 WIIL Rock to browse the clothing directly.</span></div>';
        if(status) status.textContent='';
      });
    });
  }

  function initProduct(root=document) {
    qsa('[data-product-section]',root).forEach(section=>{
      if(section.dataset.jfcsProductBound) return;
      section.dataset.jfcsProductBound='1';
      const gallery=qs('[data-product-gallery]',section);
      const slides=qsa('[data-product-media]',gallery||section);
      const thumbs=qsa('[data-product-thumb]',gallery||section);
      const showMedia=id=>{
        if(!id) return;
        slides.forEach(slide=>slide.toggleAttribute('hidden',String(slide.dataset.productMedia)!==String(id)));
        thumbs.forEach(thumb=>thumb.classList.toggle('is-active',String(thumb.dataset.productThumb)===String(id)));
      };
      thumbs.forEach(thumb=>thumb.addEventListener('click',()=>showMedia(thumb.dataset.productThumb)));
      const select=qs('[data-variant-select]',section);
      const priceEl=qs('[data-product-price]',section);
      const compareEl=qs('[data-product-compare]',section);
      const addBtn=qs('[data-add-to-cart]',section);
      const addLabel=qs('[data-add-label]',section);
      const statusEl=qs('[data-product-status]',section);
      let stickyBar=qs('[data-product-mobile-sticky]');
      if(!stickyBar){
        const title=(qs('.product-info h1',section)?.textContent||'PRODUCT').trim();
        const initialPrice=(priceEl?.textContent||'').trim();
        stickyBar=document.createElement('div');
        stickyBar.className='product-mobile-sticky';
        stickyBar.setAttribute('data-product-mobile-sticky','');
        stickyBar.setAttribute('aria-label','Quick add to cart');
        stickyBar.innerHTML='<div class="product-mobile-sticky__info"><span></span><strong data-sticky-product-price></strong></div><button type="button" class="jfcs-btn jfcs-btn--primary" data-sticky-add>ADD TO BAG</button>';
        const stickyTitle=qs('.product-mobile-sticky__info span',stickyBar);
        const stickyInitialPrice=qs('[data-sticky-product-price]',stickyBar);
        if(stickyTitle) stickyTitle.textContent=title;
        if(stickyInitialPrice) stickyInitialPrice.textContent=initialPrice;
        document.body.appendChild(stickyBar);
      }
      const stickyPrice=stickyBar?qs('[data-sticky-product-price]',stickyBar):null;
      const stickyAdd=stickyBar?qs('[data-sticky-add]',stickyBar):null;
      const updateVariant=()=>{
        if(!select) return;
        const option=select.options[select.selectedIndex];
        if(!option) return;
        const available=option.dataset.available==='true';
        if(priceEl) priceEl.textContent=option.dataset.price||priceEl.textContent;
        if(stickyPrice) stickyPrice.textContent=option.dataset.price||stickyPrice.textContent;
        if(compareEl){const compare=option.dataset.compare||'';compareEl.hidden=!compare;compareEl.textContent=compare;}
        if(addBtn) addBtn.disabled=!available;
        if(stickyAdd){stickyAdd.disabled=!available;stickyAdd.textContent=available?'ADD TO BAG':'SOLD OUT';}
        if(addLabel) addLabel.textContent=available?'ADD TO EVIDENCE BAG':'SOLD OUT';
        if(statusEl){statusEl.textContent=available?'IN STOCK / READY FOR BAD DECISIONS':'CURRENTLY UNAVAILABLE';statusEl.classList.toggle('is-unavailable',!available);}
        if(option.dataset.imageId) showMedia(option.dataset.imageId);
        try{const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}catch(e){}
      };
      select?.addEventListener('change',updateVariant);
      if(stickyAdd){stickyAdd.addEventListener('click',()=>{if(!stickyAdd.disabled) qs('[data-add-to-cart]',section)?.click();});}
      if(!select&&stickyPrice&&priceEl) stickyPrice.textContent=priceEl.textContent;
      updateVariant();
    });
  }

  function initAjaxCart(root=document){
    qsa('form[data-ajax-cart-add]',root).forEach(form=>{
      if(form.dataset.jfcsAjaxBound) return;
      form.dataset.jfcsAjaxBound='1';
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        const button=qs('button[type="submit"]',form);
        const label=qs('[data-add-label]',form)||button;
        const feedback=qs('[data-add-feedback]',form);
        const original=label?.textContent||'';
        if(button) button.disabled=true;
        if(label) label.textContent='ADDING...';
        if(feedback) feedback.textContent='';
        try{
          const addUrl=(window.JFCS?.routes?.cartAdd||'/cart/add')+'.js';
          const response=await fetch(addUrl,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          if(!response.ok) throw new Error('Cart add failed');
          await response.json();
          try{
            const sourceValue=new FormData(form).get('properties[_jfcs_source]');
            if(sourceValue&&window.JFCSAnalytics?.mirrorOrderSource) await window.JFCSAnalytics.mirrorOrderSource(sourceValue);
          }catch(e){}
          const cart=await fetch((window.JFCS?.routes?.cart||'/cart')+'.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
          qsa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
          if(label) label.textContent='ADDED ✓';
          if(feedback) feedback.innerHTML=`Added to the Evidence Bag. <a href="${window.JFCS?.routes?.cart||'/cart'}">VIEW BAG →</a>`;
          setTimeout(()=>{if(label)label.textContent=original||'ADD TO BAG';if(button)button.disabled=false;},1400);
        }catch(error){
          if(label) label.textContent=original||'TRY AGAIN';
          if(feedback) feedback.textContent='Could not add that item. Open the product and try again.';
          if(button) button.disabled=false;
        }
      });
    });
  }

  function initRecommendations(root=document){ qsa('[data-product-recommendations]',root).forEach(el=>{if(el.dataset.jfcsBound||!el.dataset.url)return;el.dataset.jfcsBound='1';fetch(el.dataset.url).then(r=>r.text()).then(text=>{const doc=new DOMParser().parseFromString(text,'text/html'),fresh=doc.querySelector('[data-product-recommendations]');if(fresh&&fresh.innerHTML.trim()){el.innerHTML=fresh.innerHTML;boot(el)}}).catch(()=>{});}); }



  function initEditorial(root=document){
    qsa('[data-article-rating]',root).forEach(widget=>{
      if(widget.dataset.jfcsBound) return;
      widget.dataset.jfcsBound='1';
      const key=`jfcs:article-rating:${widget.dataset.articleKey||'story'}`;
      const buttons=qsa('[data-rating-choice]',widget), response=qs('[data-rating-response]',widget);
      const messages={responsible:'Responsible? That is deeply suspicious, but we will allow it.',questionable:'QUESTIONABLE. Correct answer. You understood the assignment.','worth-it':'ABSOLUTELY WORTH IT. Your judgment remains impressively compromised.'};
      const apply=choice=>{buttons.forEach(btn=>{const active=btn.dataset.ratingChoice===choice;btn.classList.toggle('is-active',active);btn.setAttribute('aria-pressed',String(active));});if(response){response.hidden=false;response.textContent=messages[choice]||'Judgment recorded.';}try{localStorage.setItem(key,choice)}catch(e){}};
      try{const saved=localStorage.getItem(key);if(saved&&messages[saved])apply(saved)}catch(e){}
      buttons.forEach(btn=>btn.addEventListener('click',()=>apply(btn.dataset.ratingChoice)));
    });
    qsa('[data-article-next-choice]',root).forEach(widget=>{
      if(widget.dataset.jfcsBound) return;
      widget.dataset.jfcsBound='1';
      const buttons=qsa('[data-next-choice]',widget), outcomes=qsa('[data-next-outcome]',widget);
      const key=`jfcs:article-next:${widget.dataset.articleKey||'story'}`;
      const apply=choice=>{
        buttons.forEach(btn=>{const active=btn.dataset.nextChoice===choice;btn.classList.toggle('is-active',active);btn.setAttribute('aria-pressed',String(active));});
        outcomes.forEach(outcome=>{const active=outcome.dataset.nextOutcome===choice;outcome.hidden=!active;outcome.classList.toggle('is-active',active);});
        try{localStorage.setItem(key,choice)}catch(e){}
      };
      try{const saved=localStorage.getItem(key);if(saved&&buttons.some(btn=>btn.dataset.nextChoice===saved))apply(saved)}catch(e){}
      buttons.forEach(btn=>btn.addEventListener('click',()=>apply(btn.dataset.nextChoice)));
    });
    qsa('[data-copy-article-link]',root).forEach(button=>{if(button.dataset.jfcsBound)return;button.dataset.jfcsBound='1';button.addEventListener('click',async()=>{const original=button.textContent;try{await navigator.clipboard.writeText(location.href);button.textContent='LINK COPIED ✓'}catch(e){button.textContent='COPY FAILED'}setTimeout(()=>button.textContent=original,1400);});});

    qsa('[data-bad-library-page]',root).forEach(library=>{
      if(library.dataset.jfcsFilterBound) return;
      library.dataset.jfcsFilterBound='1';
      const buttons=qsa('[data-library-filter]',library), stories=qsa('[data-library-story]',library), status=qs('[data-library-filter-status]',library), statusLabel=qs('[data-library-filter-label]',library), clear=qs('[data-library-filter-clear]',library), noMatch=qs('[data-library-no-match]',library);
      const labels={all:'ALL BAD IDEAS','bad-idea-story':'BAD IDEA STORIES','field-report':'FIELD REPORTS','questionable-buying-guide':'BUYING GUIDES','evidence-file':'EVIDENCE FILES'};
      const valid=new Set(Object.keys(labels));
      const apply=filter=>{
        if(!valid.has(filter)) filter='all';
        let visible=0;
        buttons.forEach(button=>{const active=button.dataset.libraryFilter===filter;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});
        stories.forEach(story=>{const show=filter==='all'||story.dataset.series===filter;story.hidden=!show;if(show)visible++;});
        if(status){status.hidden=filter==='all';if(statusLabel)statusLabel.textContent=labels[filter]||'';}
        if(noMatch)noMatch.hidden=visible!==0;
        const nextHash=filter==='all'?'':`#${filter}`;
        if(location.hash!==nextHash){try{history.replaceState(null,'',`${location.pathname}${location.search}${nextHash}`)}catch(e){}}
      };
      buttons.forEach(button=>button.addEventListener('click',()=>apply(button.dataset.libraryFilter||'all')));
      clear?.addEventListener('click',()=>apply('all'));
      const initial=(location.hash||'').replace(/^#/,'');
      apply(valid.has(initial)?initial:'all');
    });
  }

  function boot(root=document){initHeader(root);initHeroes(root);initHomepageRandomLinks(root);initEvidenceLocker(root);initWtf(root);initCollection(root);initRandomCollection(root);initProduct(root);initAjaxCart(root);initRecommendations(root);initEditorial(root)}
  boot(document);document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
